export enum FixedDimensionsConsts {
  WIDTH = 400,
  CABIN_WALL_WIDTH = 20,
}
